/* DRESSFRESH 2026 · Choose your scent (sections/df-scent-choose.liquid)
   Pick-one scent tiles that drive the section's add-to-cart button (variant id, "Add <scent> to
   Cart — <price>", sold out state). Picking a tile also checks that scent in the buy panel; a
   `df:variant-change` from the buy panel (assets/df-product.js) selects the matching tile. */
(function () {
  'use strict';

  function handleize(s) {
    return String(s || '').toLowerCase().trim()
      .replace(/['"]/g, '').replace(/[^a-z0-9À-ɏ]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function select(root, tile) {
    if (!tile) return;
    root.querySelectorAll('[data-sc-key]').forEach(function (t) {
      var on = t === tile;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-checked', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
    });
    var input = root.querySelector('[data-sc-input]');
    var btn = root.querySelector('[data-sc-add]');
    var label = root.querySelector('[data-sc-label]');
    var id = tile.getAttribute('data-sc-variant');
    var name = tile.getAttribute('data-sc-name');
    var ok = tile.getAttribute('data-sc-available') === 'true' && !!id;
    if (input && id) input.value = id;
    if (btn) {
      btn.disabled = !ok;
      btn.removeAttribute('aria-disabled');
    }
    if (label && btn) {
      label.textContent = ok
        ? btn.getAttribute('data-label-add').replace('[scent]', name) + ' — ' + tile.getAttribute('data-sc-price')
        : btn.getAttribute('data-label-out').replace('[scent]', name);
    }
  }

  /* check the same scent in this product's buy panel, so both agree */
  function syncPanel(root, key) {
    var pid = root.getAttribute('data-product-id');
    var found = null;
    document.querySelectorAll('[data-df-product] [data-df-option] input[type="radio"]').forEach(function (r) {
      if (found || handleize(r.value) !== key) return;
      var json = r.closest('[data-df-product]').querySelector('[data-df-product-json]');
      if (pid && json) {
        try { if (String(JSON.parse(json.textContent).id) !== pid) return; } catch (e) { /* ignore */ }
      }
      found = r;
    });
    if (found && !found.checked) {
      found.checked = true;
      found.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function init(root) {
    if (root.dataset.scReady) return;
    root.dataset.scReady = '1';
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-sc-key]'));
    tiles.forEach(function (tile, i) {
      tile.addEventListener('click', function () {
        select(root, tile);
        syncPanel(root, tile.getAttribute('data-sc-key'));
      });
      tile.addEventListener('keydown', function (e) {
        var step = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
        if (!step) return;
        e.preventDefault();
        var next = tiles[(i + step + tiles.length) % tiles.length];
        next.focus();
        next.click();
      });
    });
    document.addEventListener('df:variant-change', function (e) {
      if (!root.isConnected || !e.detail) return;
      var pid = root.getAttribute('data-product-id');
      if (pid && e.detail.productId && String(e.detail.productId) !== pid) return;
      var keys = e.detail.keys || [];
      var match = null;
      tiles.forEach(function (t) { if (!match && keys.indexOf(t.getAttribute('data-sc-key')) > -1) match = t; });
      if (match && !match.classList.contains('is-on')) select(root, match);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-df-scentpick]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
